import { gql, useMutation } from '@apollo/client'
import { useCallback } from 'react'

const CONFIRM_EMAIL_CHANGE_MUTATION = gql`
  mutation ConfirmEmailChange($input: ConfirmEmailChangeInput!) {
    confirmEmailChange(input: $input) {
      email
    }
  }
`

type ConfirmEmailChangeMutation = {
  confirmEmailChange: { email: string | null } | null
}

type ConfirmEmailChangeMutationVariables = {
  input: { token: string }
}

export type ConfirmEmailChangeResult = { success: true; email: string | null } | { success: false }

export function useConfirmEmailChange() {
  const [mutate, { loading }] = useMutation<
    ConfirmEmailChangeMutation,
    ConfirmEmailChangeMutationVariables
  >(CONFIRM_EMAIL_CHANGE_MUTATION)

  const execute = useCallback(
    async (token: string): Promise<ConfirmEmailChangeResult> => {
      try {
        const { data } = await mutate({ variables: { input: { token } } })
        return { success: true, email: data?.confirmEmailChange?.email ?? null }
      } catch (err) {
        if (process.env.NODE_ENV !== 'production')
          console.error('[useConfirmEmailChange] mutation failed', err)

        return { success: false }
      }
    },
    [mutate]
  )

  return { execute, loading }
}
